import AirPagination from "./AirPagination"

export default  AirPagination;



// WEBPACK FOOTER //
// ./src/common/components/AirPagination/index.js